<template>
	<v-row justify="center">
		<v-dialog
			v-model="dialog"
			:fullscreen="mobile"
			persistent
			max-width="600px"
		>
			<template v-slot:activator="{ on, attrs }">
				<v-btn class="app-button button-rounding" v-bind="attrs" v-on="on">
					Registrate
				</v-btn>
			</template>
			<v-card>
				<v-card-title>
					<span class="headline">Registro</span>
				</v-card-title>
				<v-card-text>
					<v-container>
						<v-row>
							<v-col cols="12" sm="6">
								<v-text-field
									label="Nombre"
									hide-details="auto"
									v-model="name"
									solo
									required
								></v-text-field>
							</v-col>
							<v-col cols="12" sm="6">
								<v-text-field
									label="Apellido"
									required
									v-model="lastname"
									solo
									hide-details="auto"
								></v-text-field>
							</v-col>
							<!-- <v-col cols="12" sm="6">
								<v-text-field
									label="Email"
									type="email"
									v-model="email"
									solo
									hide-details="auto"
									required
								></v-text-field>
							</v-col> -->
							<v-col cols="12" sm="6">
								<v-text-field
									label="Telefono"
									v-model="phone"
									hint="Formatos válidos: +584241234567, 04241234567"
									:error="phoneError"
									solo
									required
								></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-text-field v-model="city" label="Ciudad" solo></v-text-field>
							</v-col>
						</v-row>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn class="button-rounding" color="blue darken-1" text @click="dialog = false">
						Volver
					</v-btn>
					<v-btn :loading="loading" class="button-rounding" color="blue darken-1" text @click="register">
						Registro
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>
<script>
import { api } from '../../../ajax';

export default {
	data() {
		return {
			dialog: false,
			name: "",
			lastname: "",
			phone: "",
			city: "",
			loading: false
		};
	},
	props: {
		email: String
	},
	computed: {
		mobile() {
			switch (this.$vuetify.breakpoint.name) {
				case "xs":
					return true;
				default:
					return false;
			}
		},
		phoneError() {
			return !/[+0-9]{11,15}/g.test(this.phone)
		}
	},
	methods: {
		async register() {
			if(!this.validateInputs()) {
				return
			}
			this.loading = true;
			let fd = new FormData();
			fd.append("name", this.name);
			fd.append("lastname", this.lastname);
			fd.append("phone", this.phone);
			fd.append("email", this.email);
			fd.append("city", this.city);
			fd.append("store_id", this.$route.params.id);
			await api
				.post("/web-store/add_client", fd)
				.then((res) => {
					this.loading = false;
					if (res.data.user) {
						let fd = new FormData();
						fd.append("message", "buy");
						fd.append("driver", "web");
						const data = {
							id: this.$route.params.id,
							data: fd,
						};
						this.$store.dispatch("chatStore/setUserAndCart", {
							name: this.name,
							lastname: this.lastname,
							email: this.email,
							phone: this.phone,
							city: this.city,
							store_id: this.$route.params.id,
							id: res.data.user.id
						});
						this.$store.dispatch("chatStore/show_catalogue", data);
						this.dialog = false;
					}
				});
		},
		validateInputs() {
			if (
				this.name == "" ||
				this.lastname == "" ||
				this.phone == "" ||
				!/[+0-9]{11,15}/g.test(this.phone) ||
				this.email == "" ||
				this.city == ""
			) {
				return false;
			}
			return true;
		},
	},
};
</script>
